import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import moment from 'moment';
import { quotaValidation } from '../constants';

import DurationFormatter from '../utils/duration';
import { sortByDate } from '../utils/sorting';

import userTaskActions from '../actions/userTaskActionCreators';

class UserPill extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            initialQuota: this.props.quota / 60,
            quota: this.props.quota / 60
        };
    }

    // LIFECYCLE METHODS

    componentWillReceiveProps = (nextProps) => { this.setState({ quota: nextProps.quota / 60 }); }

    // EVENT HANDLERS

    handleKeyDown = (event) => {
        if (event.key === "Enter") {
            this.handleSaveQuota();
        }
    }

    handleQuotaChange = (event) => { this.setState({ quota: event.target.value }, this.validate); }

    handleQuotaClick = () => {
        this.setState({
            quota: this.state.initialQuota,
            quotaError: false
        });

        this.props.handleSetQuotaClick(this.props.id);
    }

    handleRemove = () => { this.props.handleRemove(this.props.id); }

    handleReassign = () => { this.props.handleReassign(this.props.user); }

    handleSaveQuota = () => {
        this.validate();

        if (this.state.quotaError) return;

        this.setState({ initialQuota: this.state.quota * 60 });

        this.props.handleSaveQuota(this.state.quota, this.props.id);
    }

    // OTHER METHODS

    loadHistory = () => { this.props.dispatch(userTaskActions.loadQuotaHistoryByUserTask(this.props.userTask.id)); }

    validate = () => {
        let quotaError = !quotaValidation.test(this.state.quota);

        if (this.props.userTask && this.props.userTask.regularTimeSpent) {
            if (this.state.quota * 60 < this.props.userTask.regularTimeSpent) {
                quotaError = true;
            }
        }

        this.setState({ quotaError: quotaError });
    }

    onHoverQuota = () => { this.loadHistory(); }

    prepareContents = () => {
        let contents = [];
        let quotaHistory;
        if(this.props.quotaHistories)
            for(let i = 0; i < this.props.quotaHistories.length; i++) {
                quotaHistory = this.props.quotaHistories[i];
                contents.push(<div key={i}>{"" + quotaHistory.user.givenName + " " + quotaHistory.user.surname + " on " + moment(quotaHistory.date).format("DD.MM.YYYY.") + " changed to: " + quotaHistory.value/60 + "h"}</div>);
            }
        if(contents.length == 0)
            contents.push("No quota history.");
        return contents;
    }

    // RENDER METHOD

    render = () => {
        let text = this.props.text;
        if(this.state.quotaHistories && this.state.quotaHistories.length > 0) {
            this.state.quotaHistories(sortByDate);
        }
        let contents = this.prepareContents();
        let popover = <Popover id="assignedPopover" placement={"left"}>
                          <div className="text-center" >
                              Assigned on task: &nbsp; &nbsp; {this.props.assignedOn ? this.props.assignedOn : "Unknown"}
                          </div>
                      </Popover>;
        let quotaHistoryPopover = <Popover id="quotaHistoryPopover" placement={this.state.placement}>
                                      {contents}
                                  </Popover>;
        if(!this.props.active) {
            text = <s>{text}</s>;
        }
        if(this.props.noLongerAssigned) {
            text = <span className="user-no-longer-assigned">{text}</span>;
        }
        if (this.props.closed) {
            return (
                <tr>
                    <OverlayTrigger ref="popoverTrigger" placement="left" delay={0} overlay={popover}>
                        <td style={{"cursor" : "pointer"}}>{text}</td>
                    </OverlayTrigger>

                    <td className="text-center" style={{"cursor" : "pointer"}} onClick={this.handleQuotaClick}>
                        <OverlayTrigger ref="quotaHistoryPopoverTrigger" placement="left" delay={0} overlay={quotaHistoryPopover}>
                            <span style={{"fontSize" : "14px !important"}}>
                                {this.state.quota ? this.state.quota + " h" : "0" + " h"}
                            </span>
                        </OverlayTrigger>
                    </td>

                    <td className={this.props.noLongerAssigned ? "user-no-longer-assigned" : "text-center"} width="30%">
                        <h5>
                            {
                                this.props.userTask || this.props.regularTimeSpent || this.props.overtimeTimeSpent
                                ? DurationFormatter.format(this.props.regularTimeSpent)  + " (+ " + DurationFormatter.format(this.props.overtimeTimeSpent) + ")"
                                : ""
                            }
                        </h5>
                    </td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                </tr>
            );
        }

        return (
            <tr>
                {
                this.props.noLongerAssigned
                    ? <td style={{"cursor" : "pointer"}}>{text}</td>
                    : <OverlayTrigger ref="popoverTrigger" placement="left" delay={250} overlay={popover}>
                        <td style={{"cursor" : "pointer"}}>{text}</td>
                      </OverlayTrigger>
                }
                {
                    this.props.noLongerAssigned
                    ? <td></td>
                    :
                        this.props.editingQuota
                        ? <td className={this.state.quotaError ? "has-error" : ""}>
                            <input value={this.state.quota} onChange={this.handleQuotaChange} onBlur={this.handleSaveQuota} onKeyDown={this.handleKeyDown} type="text" className="form-control" placeholder="Hours"/>
                          </td>
                        : <td className="text-center" style={{"cursor" : "pointer"}} onClick={this.handleQuotaClick}>
                            <OverlayTrigger ref="quotaHistoryPopoverTrigger" placement="left" onMouseOver={this.props.userTask ? this.loadHistory : () => {}} overlay={quotaHistoryPopover}>
                                <span style={{"fontSize" : "14px !important"}}>
                                    {this.state.quota ? this.state.quota + " h" : "0" + " h"}
                                </span>
                            </OverlayTrigger>
                          </td>
                }

                <td className={this.props.noLongerAssigned ? "user-no-longer-assigned" : "text-center"} width="30%">
                    <h5>
                        {
                            this.props.userTask || this.props.regularTimeSpent || this.props.overtimeTimeSpent
                            ? DurationFormatter.format(this.props.regularTimeSpent)  + " (+ " + DurationFormatter.format(this.props.overtimeTimeSpent) + ")"
                            : ""
                        }
                    </h5>
                </td>
                {
                    this.props.noLongerAssigned
                    ? <td>
                        <button onClick={this.handleReassign} style={{"background" : "transparent" , "border" : "none"}}>
                            <a className="icon-btn">
                                <span>
                                    <span className="md-add"></span>
                                </span>
                            </a>
                        </button>
                    </td>
                    : <td>
                        <button onClick={this.handleRemove} style={{"background" : "transparent" , "border" : "none"}}>
                            <a className="icon-btn">
                                <span>
                                    <span className="md-remove"></span>
                                </span>
                            </a>
                        </button>
                    </td>
                }
            </tr>
        );
    }
}

UserPill.propTypes = {
    active: PropTypes.bool,
    assignedOn: PropTypes.string,
    closed: PropTypes.bool,
    dispatch: PropTypes.func,
    editingQuota: PropTypes.bool,
    handleReassign: PropTypes.func,
    handleRemove: PropTypes.func,
    handleSaveQuota: PropTypes.func,
    handleSetQuotaClick: PropTypes.func,
    id: PropTypes.number,
    noLongerAssigned: PropTypes.bool,
    overtimeTimeSpent: PropTypes.number,
    quota: PropTypes.number,
    regularTimeSpent: PropTypes.number,
    text: PropTypes.string,
    user: PropTypes.object,
    userTask: PropTypes.object,
    showQuotaHistory: PropTypes.bool
};

const mapStateToProps = (state) => {
    var histories = state.userTasks.quotaHistories;
      return {
          quotaHistories: histories
      };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UserPill);



/** WEBPACK FOOTER **
 ** ./src/app/components/UserPill.js
 **/